import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import {
  Category as Form1Icon,
  Layers as Form2Icon,
} from '@mui/icons-material';

function MaterialCompositesFormSelection() { // ✅ Updated component name
  const navigate = useNavigate();

  const forms = [
    {
      title: 'Material Composite Form 1',
      description: 'Step 1: Basic composite information.',
      icon: <Form1Icon sx={{ fontSize: 48 }} />,
      path: '/material-composites/new/form1', // ✅ Updated path
    },
    {
      title: 'Material Composite Form 2',
      description: 'Step 2: Additional composite details.',
      icon: <Form2Icon sx={{ fontSize: 48 }} />,
      path: '/material-composites/new/form2', // ✅ Updated path
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Select Material Composite Form
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
        Choose the appropriate form based on your composite type
      </Typography>

      <Grid container spacing={3}>
        {forms.map((form, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                }
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  {form.icon}
                </Box>
                <Typography variant="h6" component="h2" gutterBottom>
                  {form.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {form.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ p: 2, pt: 0 }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => navigate(form.path)}
                >
                  Select Form
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default MaterialCompositesFormSelection; // ✅ Updated export
